module.exports = __webpack_public_path__ + "static/cube18-eac6010653305b2ad134c7e27f4391f9.svg";